import { i18n } from 'i18next';
import { Language } from '../enums';

export const getLanguage = (i18n: i18n) =>
  i18n.language.toUpperCase() as Language;
